import { ReactNode, useEffect, useState } from 'react';
import { ProgressBarLine, ProgressBarWrapper } from './styles';
import { Box } from '../Box/Box';
import { Typography } from '../Typography/Typography';
import { COLORS } from '@/styles/colors';

type ProgressBarType = {
  label: ReactNode;
  count: number;
  totalCount: number;
  highlightOnComplete?: boolean;
};

export const ProgressBar = ({ label, count, totalCount, highlightOnComplete }: ProgressBarType) => {
  const [progressValue, setProgressValue] = useState(0);

  useEffect(() => {
    const progress = (count / totalCount) * 100;

    setProgressValue(progress);
  }, [count, totalCount]);

  return (
    <Box width='100%' display='flex' flexDirection='column' rowGap='2px'>
      <Box display='flex' alignItems='center' justifyContent='space-between' rowGap={2}>
        <Typography variant='bodySmall' color={COLORS.black}>
          {label}
        </Typography>
        <Typography variant='bodySmall' color={COLORS.black} fontWeight='semibold'>
          {`${count}/${totalCount}`}
        </Typography>
      </Box>
      <ProgressBarWrapper>
        <ProgressBarLine value={progressValue} highlightOnComplete={highlightOnComplete} />
      </ProgressBarWrapper>
    </Box>
  );
};
